import moment, { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/es/generate/moment';
import generatePicker from './generatePicker';

/**
 * Picker generating localization settings.
 */
Object.assign(momentGenerateConfig.locale, {
    getShortMonths: (locale: string) => {
        const date = moment().locale(locale);
        return date.localeData().months();
    },
});
export const GeneratedDatePicker = generatePicker<Moment>(momentGenerateConfig);

/**
 * @description Function to get DOM Elements.
 * @param {Element} parentNode - Parent node used for.
 * @param {Record<string, string>} styles - Styles.
 * @returns {Array} Array of DOM Elements.
 */
export const getDOMElements = (
    parentNode: Element,
    styles: Record<string, string>,
) => {
    const datePickerContainer = parentNode.getElementsByClassName(
        'ant-picker-panel-container',
    )[0];

    const weeks = parentNode.querySelector(
        '.ant-picker-date-panel thead',
    ) as Node;

    datePickerContainer.prepend(weeks);

    const [headerView1, headerView2] = parentNode.getElementsByClassName(
        'ant-picker-header-view',
    ) as HTMLCollectionOf<HTMLElement>;

    const [fromDateInput, toDateInput] =
        parentNode.getElementsByClassName('ant-picker-input');

    const clearFromButton = document.createElement('button');
    const clearToButton = document.createElement('button');

    clearFromButton.type = 'button';
    clearFromButton.className = styles.clearButton;
    clearToButton.type = 'button';
    clearToButton.className = styles.clearButton;

    return [
        headerView1,
        headerView2,
        fromDateInput,
        toDateInput,
        clearFromButton,
        clearToButton,
    ] as const;
};
